import useSWR, { mutate } from 'swr';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

export function useExpenses() {
  const { token, currentBusiness, isCookieMode, API_BASE_URL } = useAuth();

  const fetcher = ([url, businessId]: [string, string]) => {
    // Use the environment variable to construct the full API URL
    const fullUrl = `${API_BASE_URL}${url}`;
    
    const headers: any = {
    };
    
    // Only add Authorization header if not in cookie mode
    if (!isCookieMode && token) {
      headers.Authorization = `Bearer ${token}`;
    }
    
    return axios.get(fullUrl, {
      headers,
      withCredentials: isCookieMode, // This sends cookies with the request
    }).then(res => res.data);
  };

  const { data, error, isLoading } = useSWR(
    currentBusiness ? ['/expenses', currentBusiness.id] : null,
    fetcher
  );

  return {
    expenses: data,
    isLoading,
    isError: !!error,
    mutate: () => mutate(['/expenses', token, currentBusiness?.id]),
  };
}

export async function createExpense(businessId: string, expense: any, tokenOrNull: string | null, opts?: { csrfToken?: string | null, isCookieMode?: boolean }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
  const headers: any = { };
  if (opts?.isCookieMode) {
    if (opts?.csrfToken) headers['X-CSRF-Token'] = opts.csrfToken;
  } else if (tokenOrNull) {
    headers.Authorization = `Bearer ${tokenOrNull}`;
  }
  const { data } = await axios.post(
    `${API_BASE_URL}/expenses`,
    expense,
    { headers, withCredentials: !!opts?.isCookieMode }
  );
  return data;
}

export async function updateExpense(businessId: string, id: string, expense: any, tokenOrNull: string | null, opts?: { csrfToken?: string | null, isCookieMode?: boolean }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
  const headers: any = { };
  if (opts?.isCookieMode) {
    if (opts?.csrfToken) headers['X-CSRF-Token'] = opts.csrfToken;
  } else if (tokenOrNull) {
    headers.Authorization = `Bearer ${tokenOrNull}`;
  }
  const { data } = await axios.put(
    `${API_BASE_URL}/expenses/${id}`,
    expense,
    { headers, withCredentials: !!opts?.isCookieMode }
  );
  return data;
}

export async function deleteExpense(businessId: string, id: string, tokenOrNull: string | null, opts?: { csrfToken?: string | null, isCookieMode?: boolean }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
  const headers: any = { };
  if (opts?.isCookieMode) {
    if (opts?.csrfToken) headers['X-CSRF-Token'] = opts.csrfToken;
  } else if (tokenOrNull) {
    headers.Authorization = `Bearer ${tokenOrNull}`;
  }
  const { data } = await axios.delete(
    `${API_BASE_URL}/expenses/${id}`,
    { headers, withCredentials: !!opts?.isCookieMode }
  );
  return data;
} 